<template>
  <section class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-4 col-md-6 col-sm-12 text-dark">
          <div class="card card-icon p-4 shadow">
            <div class="counter-container">
              <b-skeleton width="75%" class="h5-skeleton mb-3"></b-skeleton>
              <b-skeleton width="100%" class="h1-skeleton mb-3"></b-skeleton>
            </div>
            <div class="icon-container">
              <i class="fas fa-robot bg-info"></i>
            </div>
          </div>
        </div>
        <!-- ./col -->
        <div class="col-lg-4 col-md-6 col-sm-12 text-dark">
          <div class="card card-icon p-4 shadow">
            <div class="counter-container">
              <b-skeleton width="75%" class="h5-skeleton mb-3"></b-skeleton>
              <b-skeleton width="100%" class="h1-skeleton mb-3"></b-skeleton>
            </div>
            <div class="icon-container">
              <i class="fas fa-user bg-success"></i>
            </div>
          </div>
        </div>
        <!-- ./col -->
        <div class="col-lg-4 col-md-6 col-sm-12 text-dark">
          <div class="card card-icon p-4 shadow">
            <div class="counter-container">
              <b-skeleton width="75%" class="h5-skeleton mb-3"></b-skeleton>
              <b-skeleton width="100%" class="h1-skeleton mb-3"></b-skeleton>
            </div>
            <div class="icon-container">
              <i class="fas fa-handshake bg-danger"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <section class="col-lg-12 connectedSortable">
          <div class="card">
            <div class="card-header">
              <h3 class="card-title d-flex w-100">
                <b-skeleton width="50%" height="21px"></b-skeleton>
              </h3>
            </div>
            <div class="card-body">
              <div class="tab-content p-0">
                <b-skeleton-img
                  width="100%"
                  height="300px"
                  no-aspect
                ></b-skeleton-img>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "DashboardSkeleton",
};
</script>

<style scoped>
.h3-skeleton {
  height: 20px !important;
  margin-bottom: 0.5rem !important;
}
.h1-skeleton {
  height: calc(24px + (54 - 24) * ((100vw - 300px) / (1600 - 300)))!important;
}
.card-icon {
  display: flex;
  justify-content: space-between !important;
  flex-direction: row !important;
  border: none !important;
  border-radius: 10px !important;
}
.counter-container {
  width: 75%;
}
.icon-container {
  width: 25%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.icon-container > i {
  color: #ffffff;
  font-size: 30px;
  border-radius: 10px;
  padding: 0.75rem;
}
</style>